<template>
  <div class="d-flex flex-column flex fill-height">
    <!-- router child view -->
    <router-view class="d-flex flex flex-column overflow-y-auto"></router-view>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class Dashboard extends Vue {}
</script>

<style lang="scss"></style>
